import React from 'react';
import GenericBadge from 'components/Utils/GenericBadge';
import UnreadBadge from 'components/Common/UnreadBadge';

const ListBadge = ({
  title,
  firstLine,
  secondLine,
  unread,
  avatar,
  className = '',
  id,
  alert,
  alertIcon,
  onClick,
  loading = false,
  count,
  countStyle,
  alerts,
  children,
  ...props
}) => (
  <GenericBadge
    title={title}
    alert={alert}
    alerts={alerts}
    onClick={onClick}
    alertIcon={alertIcon}
    className={`list-badge ${unread ? `unread` : ''} ${className}`}
    avatar={avatar}
    count={count}
    countStyle={countStyle}
    loading={loading}
    info={
      <>
        <span className="truncate first-line">
          {firstLine || <br />}
          {unread && <UnreadBadge unreadText=" " />}
        </span>
        {secondLine !== undefined && <span className="truncate second-line">{secondLine}</span>}
        {children}
      </>
    }
    id={id}
    {...props}
  />
);

export default ListBadge;
